import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationDashboardMemberGrowth = ({
  denominationId,
  startDate,
  endDate
}) => {
  if (startDate && endDate) {
    return axios.get(
      `/denominations/${denominationId}/member-growth-quarterly?start_date=${startDate}&end_date=${endDate}`
    );
  }

  return axios.get(`/denominations/${denominationId}/member-growth-quarterly`);
};

export const useDenominationDashboardMemberGrowth = ({
  config,
  denominationId,
  startDate,
  endDate
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "denomination-dashboard-member-growth",
      denominationId,
      startDate,
      endDate
    ],
    queryFn: () =>
      getDenominationDashboardMemberGrowth({
        denominationId,
        startDate,
        endDate
      }),
    enabled: !!denominationId,
    select: data => data.result
  });
};
